// Navegación del panel en cuatro grupos.
//
// `roles` refleja EXACTAMENTE los roles de la ruta equivalente en
// Route/Routes.jsx: el filtrado de LayoutRoutes.jsx no se toca, así que
// si aquí se abre un item que la ruta no permite, el enlace lleva al
// redirect por defecto. Al añadir una ruta, copia sus roles tal cual.

export const MENUITEMS = [
  {
    menutitle: 'GENERAL',
    Items: [
      { path: '/dashboard', icon: 'ri-dashboard-line', title: 'Dashboard', roles: ['ADMIN', 'ADMIN_ASSISTANT'] },
      { path: '/critical-alerts', icon: 'ri-alarm-warning-line', title: 'Alertas críticas', roles: ['ADMIN', 'ADMIN_ASSISTANT'] },
    ],
  },
  {
    menutitle: 'COMERCIAL',
    Items: [
      { path: '/order', icon: 'ri-file-list-3-line', title: 'Órdenes', roles: ['ADMIN', 'ADMIN_ASSISTANT', 'ASSISTANT'] },
      { path: '/product', icon: 'ri-box-3-line', title: 'Productos', roles: ['ADMIN', 'ADMIN_ASSISTANT', 'ASSISTANT'] },
      { path: '/category', icon: 'ri-price-tag-3-line', title: 'Categorías', roles: ['ADMIN', 'ADMIN_ASSISTANT', 'ASSISTANT'] },
      { path: '/banner', icon: 'ri-image-line', title: 'Banners', roles: ['ADMIN', 'ADMIN_ASSISTANT'] },
    ],
  },
  {
    menutitle: 'RED',
    Items: [
      { path: '/user', icon: 'ri-team-line', title: 'Usuarios', roles: ['ADMIN', 'ADMIN_ASSISTANT', 'ASSISTANT'] },
      { path: '/rank', icon: 'ri-medal-line', title: 'Rangos', roles: ['ADMIN', 'ADMIN_ASSISTANT', 'ASSISTANT'] },
      { path: '/influencer-bonus', icon: 'ri-vip-crown-line', title: 'Bonos influencer', roles: ['ADMIN', 'ADMIN_ASSISTANT', 'ASSISTANT'] },
      { path: '/loyalty', icon: 'ri-gift-line', title: 'Lealtad', roles: ['ADMIN', 'ADMIN_ASSISTANT', 'ASSISTANT'] },
      { path: '/withdrawal', icon: 'ri-wallet-3-line', title: 'Retiros', roles: ['ADMIN', 'ADMIN_ASSISTANT'] },
    ],
  },
  {
    menutitle: 'CONFIGURACIÓN',
    Items: [
      { path: '/administrator', icon: 'ri-shield-user-line', title: 'Administradores', roles: ['ADMIN'] },
      { path: '/logistics', icon: 'ri-earth-line', title: 'Países y logística', roles: ['ADMIN', 'ASSISTANT'] },
      { path: '/support', icon: 'ri-customer-service-2-line', title: 'Soporte', roles: ['ADMIN'] },
      // "Ajustes" (/setting) retirado: servia la tabla demo de la plantilla
      // Cuba con datos ficticios. Vuelve cuando exista la pantalla real.
    ],
  },
];

// Los cuatro destinos de la barra inferior en móvil. El quinto ("Menú")
// abre el cajón y lo pone la propia barra.
export const MOBILE_ITEMS = [
  { path: '/dashboard', icon: 'ri-home-4-line', title: 'Inicio', roles: ['ADMIN', 'ADMIN_ASSISTANT'] },
  { path: '/order', icon: 'ri-file-list-3-line', title: 'Órdenes', roles: ['ADMIN', 'ADMIN_ASSISTANT', 'ASSISTANT'] },
  { path: '/user', icon: 'ri-team-line', title: 'Usuarios', roles: ['ADMIN', 'ADMIN_ASSISTANT', 'ASSISTANT'] },
  { path: '/critical-alerts', icon: 'ri-alarm-warning-line', title: 'Alertas', roles: ['ADMIN', 'ADMIN_ASSISTANT'] },
];

/** Mismo mecanismo que usaba SidebarMenuItems: sin `roles` = visible. */
export const visibleFor = (role, items) =>
  items.filter((item) => !item.roles || item.roles.includes(role));

export const visibleGroups = (role) =>
  MENUITEMS.map((group) => ({ ...group, Items: visibleFor(role, group.Items) }))
    .filter((group) => group.Items.length > 0);
